import { render } from "./edit-supplier-address.vue?vue&type=template&id=26843713"
import script from "./edit-supplier-address.vue?vue&type=script&lang=js"
export * from "./edit-supplier-address.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__